<app-layer-details-position
  *ngIf="layer.data.position"
  [position]="layer.data.position"
></app-layer-details-position>
<app-layer-details-geolocation
  *ngIf="layer.data.position"
  [position]="layer.data.position"
></app-layer-details-geolocation>
